//@vendor
const moment = require('moment');
const get = require('lodash/object/get');
const { createActions } = require('redux-actions');
//@actions
const { validateAndExecute } = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');
const { cancelDossier, retrieveAresDossier } = require('./aresDossier');
//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { formatAmount } = require('utilities/currencyHelper');
const download = require('downloadjs');
const BrowserUtils = require('utilities/browserUtils');
const DateHelper = require('utilities/dateHelper');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @core
const { formatText } = require('core/i18n').i18n;

//@constants
const {
    PRE_CONTRACTUAL_EASY_LOAN_MAIL,
    EASY_LOAN_LEGAL_CHECK,
    NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES,
    EVIDENCE_EASY_LOAN
} = require('constants/flagBasedFeatures');
const { DATE_FORMAT_API, WIZARD_SECOND_STEP, WIZARD_THIRD_STEP, WIZARD_FIRST_STEP, EURO_TEXT, EASY_LOAN_MAILTYPE, EASY_LOAN_PRODUCT } = require('constants/index');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const {
    payrollLoanCommon, loanPurposes, DEFAULT_BEFORE_STEP,
    VERSION_2,
    contractEasyLoan: {
        LANGUAGE,
        PAYMENT_DAY_END_OF_MONTH,
        PRODUCT_TYPE,
        contractEasyLoanEmail: {
            TEMPLATE_CODE,
        }
    },
    amortizationTypes
} = require('../loansConstants/index');
const translationContractLoanPdfViewerINE = require("../components/contracts/contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");
//@helpers
const {
    downLoadDocumentInOtherPage
} = require('../loansUtilities/loansHelper');

const simpleActions = createActions(
    'CONTRACT_EASY_LOAN_ASNEF',
    'CONTRACT_EASY_LOAN_ASNEF_ERROR',
    'CONTRACT_EASY_LOAN_ASNEF_FAILURE',
    'CONTRACT_EASY_LOAN_ASNEF_SUCCESS',

    'CONTRACT_EASY_LOAN_DOWNLOAD_DOCUMENT',
    'CONTRACT_EASY_LOAN_DOWNLOAD_DOCUMENT_ERROR',
    'CONTRACT_EASY_LOAN_DOWNLOAD_DOCUMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_DOWNLOAD_PRINT_DOCUMENT',
    'CONTRACT_EASY_LOAN_DOWNLOAD_PRINT_DOCUMENT_ERROR',
    'CONTRACT_EASY_LOAN_DOWNLOAD_PRINT_DOCUMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_FORMALIZE',
    'CONTRACT_EASY_LOAN_FORMALIZE_ERROR',
    'CONTRACT_EASY_LOAN_FORMALIZE_SUCCESS',

    'CONTRACT_EASY_LOAN_GET_PROPOSITION',
    'CONTRACT_EASY_LOAN_GET_PROPOSITION_ERROR',
    'CONTRACT_EASY_LOAN_GET_PROPOSITION_SUCCESS',

    'CONTRACT_EASY_LOAN_GET_TOTAL_IMPORT',
    'CONTRACT_EASY_LOAN_GET_TOTAL_IMPORT_ERROR',
    'CONTRACT_EASY_LOAN_GET_TOTAL_IMPORT_SUCCESS',

    'CONTRACT_EASY_LOAN_HIRING_DOCUMENTS',
    'CONTRACT_EASY_LOAN_HIRING_DOCUMENTS_ERROR',
    'CONTRACT_EASY_LOAN_HIRING_DOCUMENTS_SUCCESS',

    'CONTRACT_EASY_LOAN_INSTALLMENT',
    'CONTRACT_EASY_LOAN_INSTALLMENT_ERROR',
    'CONTRACT_EASY_LOAN_INSTALLMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_MIN_INSTALLMENT',
    'CONTRACT_EASY_LOAN_MIN_INSTALLMENT_ERROR',
    'CONTRACT_EASY_LOAN_MIN_INSTALLMENT_SUCCESS',

    'CONTRACT_EASY_LOAN_NOT_AVAILABLE',

    'CONTRACT_EASY_LOAN_PRE_FILL',
    'CONTRACT_EASY_LOAN_PRE_FILL_ERROR',
    'CONTRACT_EASY_LOAN_PRE_FILL_SUCCESS',

    'CONTRACT_EASY_LOAN_RESET_STEP',
    'CONTRACT_EASY_LOAN_SET_ACCOUNT',
    'CONTRACT_EASY_LOAN_SET_LOAN_AMOUNT',
    'CONTRACT_EASY_LOAN_SET_PAYMENT_DAY',
    'CONTRACT_EASY_LOAN_SET_PURPOSE',
    'CONTRACT_EASY_LOAN_SET_STEP',
    'CONTRACT_EASY_LOAN_SET_TERM',
    'CONTRACT_EASY_LOAN_TOGGLE_AGREE_CHECKBOX',
    'CONTRACT_EASY_LOAN_INE_TOGGLE_AGREE_CHECKBOX',
    'CONTRACT_EASY_LOAN_VALIDATE_STEP',
    'CONTRACT_EASY_LOAN_AND_MORTGAGES_VALIDATE_STEP',
    'CONTRACT_EASY_LOAN_WILL_LEAVE',

    'PAYROLL_LOAN_REQUEST_EMAIL_PRECONTRACTUAL',
    'PAYROLL_LOAN_REQUEST_EMAIL_PRECONTRACTUAL_SUCCESS',
    'PAYROLL_LOAN_REQUEST_EMAIL_PRECONTRACTUAL_ERROR',

    'GET_EASY_LOAN_INE_DOCUMENT',
    'GET_EASY_LOAN_INE_DOCUMENT_SUCCESS',
    'GET_EASY_LOAN_INE_DOCUMENT_ERROR',

    'GET_EASY_LOAN_POLICY_DOCUMENT',
    'GET_EASY_LOAN_POLICY_DOCUMENT_SUCCESS',
    'GET_EASY_LOAN_POLICY_DOCUMENT_ERROR',

    'CONTRACT_EASY_LOAN_EMAIL_SUCCESS',
    'CONTRACT_EASY_LOAN_EMAIL_ERROR',

    'CONTRACT_EASY_LOAN_INIT_ONE_SUCCESS',
    'CONTRACT_EASY_LOAN_INIT_TWO_SUCCESS',
    'CONTRACT_EASY_LOAN_INIT_ERROR',
    'CONTRACT_EASY_LOAN_INIT_LOADING',
    'CONTRACT_EASY_LOAN_OFFICE_INE_PRINT',
    'OFFICE_PRINT_RESET',
    'CONTRACT_EASY_LOAN_OFFICE_CONTRACT_PRINT',
    'SET_INIT_API_FLAG',
    'CONTRACT_EASY_LOAN_AGREE_RESET',
    'RESET_MAIL_SENT',
    'CONTRACT_EASY_LOAN_SCROLL_DOWN_POLICY',


);

const setInitApiFlag = (initAPIFlag, mailAPIFlag, checkboxFlag, btnFlag) => dispatch => {
    dispatch(simpleActions.setInitApiFlag({ initAPIFlag, mailAPIFlag, checkboxFlag, btnFlag }))
}

const officePrintReset = (officePrintStepThree) => dispatch => {
    dispatch(simpleActions.officePrintReset({ officePrintStepThree }))
}

const resetMailSent = (resetMailSent) => dispatch => {
    dispatch(simpleActions.resetMailSent({ resetMailSent }))
}


const onDownloadDocument = (productName) => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const accounts = getState().accounts;

    const isFetchingZip = immContractEasyLoan.get('isFetchingZip');

    if (!isFetchingZip) {
        const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
        const financedCommission = immContractEasyLoan.get('indCapson') === amortizationTypes.YES ?
            payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;

        const params = {
            header: {
                responseType: 'arraybuffer'
            },
            query: {
                amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
                calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount']), 'es'),
                capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
                clientAccountCode: accounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']),
                dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
                endOfMonth,
                financedCommission,
                firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
                loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
                productDuration: immContractEasyLoan.get('selectedTerm').toString(),
                propositionContractNumber: immContractEasyLoan.get('contractNumber'),
                propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
                tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
                tin: formatAmount(immContractEasyLoan.get('tin'), 'es'),
                year: immContractEasyLoan.get('propositionYear'),
                productType: PRODUCT_TYPE
            }
        };

        dispatch(simpleActions.contractEasyLoanDownloadDocument());
        APIPost({ dispatch, endpoint: 'loanHiringDocumentsZip', params })
            .then(response => {
                dispatch(simpleActions.contractEasyLoanDownloadDocumentSuccess());
                download(response.xhr.response, `${productName}.zip`, 'application/zip');
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractEasyLoanDownloadDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const onPrintDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const documents = immContractEasyLoan.get('documents');
    const data = [new Uint8Array(documents)];

    const blobObject = new Blob(data, { type: 'application/pdf' });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(blobObject);
    } else {
        const blobURL = window.URL.createObjectURL(blobObject);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const downloadPreContractDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;

    const params = {
        query: {
            estandar: immContractEasyLoan.get('standard'),
            subtipo: immContractEasyLoan.get('subtype'),
            tipo: immContractEasyLoan.get('type'),
            idioma: LANGUAGE
        }
    };

    dispatch(simpleActions.contractEasyLoanDownloadPrintDocument());
    APIGet({ dispatch, endpoint: 'requestPreContractActive', params }).then(response => {
        const pdfUrl = get(response, 'response[0].url');
        if (!!pdfUrl) {
            window.open(pdfUrl);
        }
        dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentError());
        });
};

const sendEasyLoanSimpleEmail = (mailType, documentId) => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const contractNumberAccount = 0;
    const acceptanceText = mailType !== EASY_LOAN_MAILTYPE.PRECONTRACTUAL && __CONTACT_CENTER__ ? 'NA' : mailType !== EASY_LOAN_MAILTYPE.PRECONTRACTUAL && !__CONTACT_CENTER__ ? formatText(translationContractLoanPdfViewerINE.EASY_LOAN_TITLE_CONTRACT_DRAFT_DOCUMENT) : !isPrintOfficeMode() ? formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX) : formatText(translationContractLoanPdfViewerINE.SIMPLE_EMAIL)
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const params = !!documentId && {
        query: {
            mailType: mailType,
            documentId: documentId,
            product: {
                standard: immContractEasyLoan.get('standard'),
                subType: immContractEasyLoan.get('subtype'),
                type: immContractEasyLoan.get('type'),
            },
            contractNumberAccount,
            acceptanceText,
            scrolldown: !(__CONTACT_CENTER__ && !isPrintOfficeMode())
        }
    };
    if (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && getState().flagBasedFeatures.get(EVIDENCE_EASY_LOAN)) {
        params.query.operationProcessId = mailType === EASY_LOAN_MAILTYPE.PRECONTRACTUAL ? immContractEasyLoan.get('operationProcessIdINE') : immContractEasyLoan.get('operationProcessIdPolicy')
    }

    APIPost({
        dispatch,
        endpoint: 'sendOverDraftSimpleEmail',
        params
    })
        .then(() => {
            dispatch(simpleActions.contractEasyLoanEmailSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanEmailError());
            } else {
                throw response;
            }
        });
}

const downloanEasyLoanContractDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const immAccounts = getState().accounts;

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: immContractEasyLoan.get('propositionYear'),
            clientAccountCode: immAccounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']),
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            dueDate: DateHelper.formatDate(immContractEasyLoan.get('loanDueDate'), DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractEasyLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'requestEasyLoanContractDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentError());
        });
};

const getLoanContractDocuments = (processType = EASY_LOAN_MAILTYPE.CONTRACTUAL, operationProcessId = '') => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    operationProcessId = processType === EASY_LOAN_MAILTYPE.PRECONTRACTUAL ? immContractEasyLoan.get('operationProcessIdINE') : immContractEasyLoan.get('operationProcessIdPolicy');

    processType === EASY_LOAN_MAILTYPE.PRECONTRACTUAL ?
        dispatch(simpleActions.getEasyLoanIneDocument()) :
        dispatch(simpleActions.getEasyLoanPolicyDocument());
    if (operationProcessId && processType) {
        APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${processType}/documents`)
            .then(response => {
                const { base64Document, temporaryDocumentId } = response;
                processType === EASY_LOAN_MAILTYPE.PRECONTRACTUAL ?
                    dispatch(simpleActions.getEasyLoanIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }))
                    : dispatch(simpleActions.getEasyLoanPolicyDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));

            })
            .catch(() => {
                processType === EASY_LOAN_MAILTYPE.PRECONTRACTUAL ?
                    dispatch(simpleActions.getEasyLoanIneDocumentError()) :
                    dispatch(simpleActions.getEasyLoanPolicyDocumentError());
            });
    }
}

const getEasyLoanINEDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;

    const params = {
        header: {
            version: VERSION_2
        },
        query: {
            year: immContractEasyLoan.get('propositionYear'),
            calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount']), 'es'),
            financedCommission: immContractEasyLoan.get('indCapson') === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            tin: formatAmount(immContractEasyLoan.get('tin'), 'es'),
            productType: PRODUCT_TYPE,
            wellFinancedDenomination: ''
        }
    };

    dispatch(simpleActions.getEasyLoanIneDocument());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocumentV2', params }).then(response => {
        const { base64, documentId } = response;
        dispatch(simpleActions.getEasyLoanIneDocumentSuccess({ base64, documentId }));
    })
        .catch(() => {
            dispatch(simpleActions.getEasyLoanIneDocumentError());
        });
};

const getEasyLoanPolicyDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const immAccounts = getState().accounts;

    const params = {
        header: {
            version: VERSION_2
        },
        query: {
            year: immContractEasyLoan.get('propositionYear'),
            clientAccountCode: immAccounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']),
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            dueDate: DateHelper.formatDate(immContractEasyLoan.get('loanDueDate'), DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            tin: formatAmount(immContractEasyLoan.get('tin'), 'es'),
            productType: PRODUCT_TYPE,
            wellFinancedDenomination: ''
        }
    };

    dispatch(simpleActions.getEasyLoanPolicyDocument());
    APIPost({ dispatch, endpoint: 'requestEasyLoanContractDocumentV2', params }).then(response => {
        const { base64, documentId } = response;
        dispatch(simpleActions.getEasyLoanPolicyDocumentSuccess({ base64, documentId }));

    })
        .catch(() => {
            dispatch(simpleActions.getEasyLoanPolicyDocumentError());
        });
};

const downloadINEDocument = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: immContractEasyLoan.get('propositionYear'),
            calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount'])),
            financedCommission: immContractEasyLoan.get('indCapson') === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            propositionContractNumber: immContractEasyLoan.get('contractNumber'),
            propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            tin: formatAmount(immContractEasyLoan.get('tin')),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractEasyLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractEasyLoanDownloadPrintDocumentError());
        });
};

const getHiringDocumentsRequest = (getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const accounts = getState().accounts;
    const financedCommission = immContractEasyLoan.get('indCapson') === amortizationTypes.YES ?
        payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
    const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;

    return {
        amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
        calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount']), 'es'),
        capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
        clientAccountCode: accounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']),
        dueDate: moment(immContractEasyLoan.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
        endOfMonth,
        financedCommission,
        firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
        loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
        productDuration: immContractEasyLoan.get('selectedTerm').toString(),
        propositionContractNumber: immContractEasyLoan.get('contractNumber'),
        propositionNumber: immContractEasyLoan.get('propositionNumber').toString(),
        tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
        tin: formatAmount(immContractEasyLoan.get('tin'), 'es'),
        year: immContractEasyLoan.get('propositionYear'),
        productType: PRODUCT_TYPE
    }
}

const sendLoansPrecontractualEmail = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    dispatch(simpleActions.payrollLoanRequestEmailPrecontractual());
    const params = {
        query: {
            producto: immContractEasyLoan.get('type'),
            standard: immContractEasyLoan.get('standard'),
            subproducto: immContractEasyLoan.get('subtype'),
            templateCode: TEMPLATE_CODE,
            hiringDocumentRequest: getHiringDocumentsRequest(getState)
        }
    };
    return APIPost({
        dispatch,
        endpoint: 'sendPrecontractualDocumentMail',
        params
    })
        .then(() => {
            dispatch(simpleActions.payrollLoanRequestEmailPrecontractualSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.payrollLoanRequestEmailPrecontractualError());
            } else {
                throw response;
            }
        });
}

const getHiringDocuments = () => (dispatch, getState) => {
    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: getHiringDocumentsRequest(getState)
    };

    dispatch(simpleActions.contractEasyLoanHiringDocuments());
    APIPost({ dispatch, endpoint: 'loanHiringDocuments', params })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanHiringDocumentsSuccess({ response: response.xhr.response }));
            const immFlagBasedFeatures = getState().flagBasedFeatures;
            if ((!__CONTACT_CENTER__ && isPrintOfficeMode()) && immFlagBasedFeatures.get(PRE_CONTRACTUAL_EASY_LOAN_MAIL)) {
                dispatch(sendLoansPrecontractualEmail());
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanHiringDocumentsError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const preFillContractEasyLoan = (segmentedLoan) => (dispatch) => {
    let openingCommission = get(segmentedLoan, 'comisionApertura', 0);
    const importe = parseFloat(get(segmentedLoan, 'importeMaximo'));
    const termMin = get(segmentedLoan, 'plazoMinimo', 0);
    const termMax = get(segmentedLoan, 'plazoMaximo', 0);

    openingCommission = parseFloat(openingCommission.replace(',', '.'));

    const openingCommissionMinimum = parseFloat(get(segmentedLoan, 'comisionAperturaMin'));
    const openingCommissionAmount = importe * openingCommission / 100;

    const comisionApertura = openingCommissionAmount < openingCommissionMinimum ?
        openingCommissionMinimum : openingCommissionAmount;

    const promiseArray = [];

    const query = {
        indCapson: 'N',
        indIntccp: 'N',
        divisa: get(segmentedLoan, 'divisa', EURO_TEXT),
        importe,
        indicaPrecios: 'E', //fixed value
        tipodeproducto: get(segmentedLoan, 'tipoPagoAniversario', 0),
        subtipodeproducto: get(segmentedLoan, 'subtipoPagoAniversario', 0),
        codigodeestandar: get(segmentedLoan, 'erPagoAniversario', 0),
        comisionApertura
    };

    if (termMax > 0) {
        const queryMin = Object.assign({}, query, { plazo: termMax });
        promiseArray.push(APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params: { query: queryMin } }));
    }

    if (termMin > 0) {
        const queryMax = Object.assign({}, query, { plazo: termMin });
        promiseArray.push(APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params: { query: queryMax } }));
    }

    dispatch(simpleActions.contractEasyLoanPreFill());
    return Promise.all(promiseArray)
        .then(response => (Object.assign(segmentedLoan, {
            minTae: get(response, '0.tae', {}),
            maxTae: get(response, '1.tae', {})
        })))
        .then(response => dispatch(simpleActions.contractEasyLoanPreFillSuccess({ ...response })))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanPreFillError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getRemainingInfo = (propositionNumber, propositionYear) => dispatch => {
    const params = {
        query: {
            anio: propositionYear,
            numeroPropuesta: propositionNumber
        }
    };

    const promises = [];

    const amortizationPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanAmortizationAmortization'
    });
    promises.push(amortizationPromise);

    const initialDataPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanInitialData'
    });
    promises.push(initialDataPromise);

    return Promise.all(promises).then(responses => ({
        amortizationReponse: responses[0],
        initialDataResponse: responses[1]
    }));
};

const requestMinInstallmentQuantity = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const limit = immContractEasyLoan.get('quotaLimit');
    const totalAmount = immContractEasyLoan.get('selectedAmount');
    const quotaLimit = totalAmount < limit ? totalAmount : limit; // Jira:OPE099-14156

    const params = {
        query: {
            tin: immContractEasyLoan.get('tin'),
            totalAmount,
            installmentAmount: quotaLimit
        }
    };
    dispatch(simpleActions.contractEasyLoanMinInstallment());
    APIGet({ dispatch, endpoint: 'minimumInstallmentQuantity', params })
        .then(response => dispatch(simpleActions.contractEasyLoanMinInstallmentSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanMinInstallmentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getProductInfo = (paymentDaySelected, immContractEasyLoan) => {
    let type, subtype, standard, indCapson, indIntccp;

    if (paymentDaySelected === PAYMENT_DAY_END_OF_MONTH) {
        standard = immContractEasyLoan.get('standard');
        subtype = immContractEasyLoan.get('subtype');
        type = immContractEasyLoan.get('type');
    } else {
        standard = immContractEasyLoan.get('aniversaryStandard');
        subtype = immContractEasyLoan.get('aniversarySubtype');
        type = immContractEasyLoan.get('aniversaryType');
        indCapson = 'N';
        indIntccp = 'N';
    }

    return {
        standard,
        type,
        subtype,
        indCapson,
        indIntccp
    }
}

const getPropositionNumber = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const newEasyLoanFeatureFlag = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
    const evidenceEasyLoanFeatureFlag = getState().flagBasedFeatures.get(EVIDENCE_EASY_LOAN);
    if (immContractEasyLoan.get('fetchingProposition')) {
        return;
    }

    const paymentDaySelected = immContractEasyLoan.get('paymentDaySelected');
    const productInfo = getProductInfo(paymentDaySelected, immContractEasyLoan);

    let propositionNumber, propositionYear, contractNumber;

    const params = {
        query: {
            importePpta: {
                importe: immContractEasyLoan.get('selectedAmount'),
                divisa: immContractEasyLoan.get('currency')
            },
            plazoPpta: {
                numerodeunidades: immContractEasyLoan.get('selectedTerm'),
                unidaddetiempo: 'M'
            },
            finalidadPpta: '99',
            tipoPreciosOpera: 'E',
            canalOperacion: 'RED',
            estandar: {
                codigodeestandar: productInfo.standard,
                subtipodeproducto: {
                    subtipodeproducto: productInfo.subtype,
                    tipodeproducto: {
                        tipodeproducto: productInfo.type
                    }
                }
            }
        }
    };

    dispatch(simpleActions.contractEasyLoanGetProposition());
    APIPost({ dispatch, endpoint: 'contractEasyLoanPropositionNumber', params })
        .then(response => {
            propositionNumber = get(response, 'propuesta.numerodepropuesta');
            propositionYear = get(response, 'propuesta.anio');
            contractNumber = get(response, 'contrato.numerodecontrato');
            return dispatch(getRemainingInfo(propositionNumber, propositionYear));
        })
        .then(response => {
            const { amortizationReponse, initialDataResponse } = response;
            return dispatch(
                simpleActions.contractEasyLoanGetPropositionSuccess({
                    response: {
                        propositionNumber,
                        propositionYear,
                        contractNumber,
                        lackDate: initialDataResponse.fechaFinCarencia,
                        loanDueDate: initialDataResponse.fechaVctoPrestamos,
                        chargeOffDate: amortizationReponse.fechaAmortiz,
                        chargeOffAnniversaryDate: get(amortizationReponse, 'listaFechasAmortiz.fechaAmortiz.0.fechaAmortiz1')
                    }
                })
            );
        })
        .then(() => {
            const initAPIFlag = immContractEasyLoan.get('initAPIFlag');
            newEasyLoanFeatureFlag && evidenceEasyLoanFeatureFlag && initAPIFlag && dispatch(getContractEasyLoanInitOne());
            newEasyLoanFeatureFlag && !evidenceEasyLoanFeatureFlag && dispatch(getEasyLoanINEDocument());
            !newEasyLoanFeatureFlag && !evidenceEasyLoanFeatureFlag && dispatch(getHiringDocuments());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanGetPropositionError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getInitParams = (initCall) => (dispatch, getState) => {

    const immContractEasyLoan = getState().contractEasyLoan;
    const accounts = getState().accounts;
    const immAccount = accounts.getIn(['byId', immContractEasyLoan.get('selectedAccount'), 'iban']);
    const fechaVencimiento = immContractEasyLoan.get('loanDueDate');
    const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const financedCommission = immContractEasyLoan.get('indCapson') === amortizationTypes.YES ?
        payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
    const operationProcessIdINE = immContractEasyLoan.get('operationProcessIdINE');

    const params = {
        query:
        {
            account: immAccount,
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            calculatedOpeningCommission: formatAmount(immContractEasyLoan.getIn(['openingCommission', 'amount']), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
            contractNumberAccount: 0,
            dueDate: fechaVencimiento,
            endOfMonth: endOfMonth,
            financedCommission: financedCommission,
            firstTime: true,
            loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
            processType: initCall === 1 ? EASY_LOAN_MAILTYPE.PRECONTRACTUAL : EASY_LOAN_MAILTYPE.CONTRACTUAL,
            product: {
                standard: immContractEasyLoan.get('standard'),
                subType: immContractEasyLoan.get('subtype'),
                type: immContractEasyLoan.get('type'),
            },
            productDuration: immContractEasyLoan.get('selectedTerm').toString(),
            productType: PRODUCT_TYPE,
            propositionContractNumber: immContractEasyLoan.get("contractNumber"),
            propositionNumber: immContractEasyLoan.get('propositionNumber'),
            tin: immContractEasyLoan.get('tin'),
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            term: immContractEasyLoan.get('selectedTerm').toString(),
            year: immContractEasyLoan.get('propositionYear'),
        }
    }

    if (initCall === 2) {
        params.query.attachedEvidences = [...operationProcessIdINE];
    }

    return params
}

const getContractEasyLoanInitOne = () => (dispatch) => {

    dispatch(simpleActions.contractEasyLoanInitLoading());

    const params = dispatch(getInitParams(1));


    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            const isContactCenter = __CONTACT_CENTER__;
            const isPrintOffice = isPrintOfficeMode();
            dispatch(simpleActions.contractEasyLoanInitOneSuccess({ operationProcessIdINE: response.operationProcessId }));
            if ((isContactCenter && !isPrintOffice)) {
                dispatch(getContractEasyLoanInitTwo());
            } else {
                dispatch(getLoanContractDocuments(EASY_LOAN_MAILTYPE.PRECONTRACTUAL))
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanInitError());
            } else {
                throw response;
            }
        });
}

const getContractEasyLoanInitTwo = () => (dispatch) => {

    dispatch(simpleActions.contractEasyLoanInitLoading());
    const params = dispatch(getInitParams(2))
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(simpleActions.contractEasyLoanInitTwoSuccess({ operationProcessIdPolicy: response.operationProcessId }));
            const isContactCenter = __CONTACT_CENTER__;
            if (isContactCenter && !isPrintOfficeMode()) {
                dispatch(getLoanContractDocuments(EASY_LOAN_MAILTYPE.PRECONTRACTUAL))
            } else {
                dispatch(getLoanContractDocuments(EASY_LOAN_MAILTYPE.CONTRACTUAL));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanInitError());
            } else {
                throw response;
            }
        });
};

const formalizeQuery = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const documentId = immContractEasyLoan.get('fileEasyLoanPolicyDocumentId')
    const immAccounts = getState().accounts.get('byId');
    const immAccount = immAccounts.get(immContractEasyLoan.get('selectedAccount'));
    const fechaVencimiento = immContractEasyLoan.get('loanDueDate');
    const operationProcessIdPolicy = immContractEasyLoan.get('operationProcessIdPolicy')
    const scrollDownPolicy = immContractEasyLoan.get('scrollDownPolicy')
    const acceptanceText = EASY_LOAN_MAILTYPE.CONTRACTUAL !== EASY_LOAN_MAILTYPE.PRECONTRACTUAL && __CONTACT_CENTER__ ? 'NA' : EASY_LOAN_MAILTYPE.CONTRACTUAL !== EASY_LOAN_MAILTYPE.PRECONTRACTUAL && !__CONTACT_CENTER__ ? formatText(translationContractLoanPdfViewerINE.EASY_LOAN_TITLE_CONTRACT_DRAFT_DOCUMENT) : !isPrintOfficeMode() ? formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX) : formatText(translationContractLoanPdfViewerINE.SIMPLE_EMAIL)

    let diaPagoFinMes;
    let fechaPrimerCargo;

    if (immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH) {
        diaPagoFinMes = amortizationTypes.YES;
        fechaPrimerCargo = immContractEasyLoan.get('lackDate') || immContractEasyLoan.get('chargeOffDate');
    } else {
        diaPagoFinMes = amortizationTypes.NO;
        fechaPrimerCargo = immContractEasyLoan.get('chargeOffAnniversaryDate');
    }

    const params = {
        header: {
            version: VERSION_2
        },
        query: {
            accountBban: immAccount.getIn(['ibanComplex', 'codbban']),
            accountContractNumber: immAccount.get('newContractNumber'),
            accountPrefix: immAccount.getIn(["ibanComplex", "pais"]) + immAccount.getIn(["ibanComplex", "digitodecontrol"]), // IBAN
            amount: formatAmount(immContractEasyLoan.get('selectedAmount'), 'es'),
            capitalizedOpeningCommissionIndicator: immContractEasyLoan.get('indCapson'),
            dueDate: fechaVencimiento,
            endOfMonth: immContractEasyLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            endOfMonthDate: diaPagoFinMes,
            financedCommission: !!immContractEasyLoan.get('indCapson'),
            firstChargeDate: fechaPrimerCargo,
            formalizationPurpose: '99', // Fixed value. God's knows what is this
            installment: formatAmount(immContractEasyLoan.getIn(['installment', 'amount']), 'es'),
            loanPurpose: loanPurposes[immContractEasyLoan.get('selectedPurpose')],
            product: immAccount.get('newProduct'),
            subProduct: '802',
            propositionContractNumber: immContractEasyLoan.get("contractNumber"),
            propositionNumber: immContractEasyLoan.get('propositionNumber'),
            registerDate: moment().startOf('day').format(DATE_FORMAT_API),
            tae: formatAmount(immContractEasyLoan.get('tae'), 'es'),
            term: immContractEasyLoan.get('selectedTerm').toString(),
            year: immContractEasyLoan.get('propositionYear'),
            documentId,
            operationProcessId: operationProcessIdPolicy,
            scrolldown: scrollDownPolicy,
            termsAndConds: {
                acceptedText: acceptanceText
            }
        }
    };
    if (immFlagBasedFeatures.get(EASY_LOAN_LEGAL_CHECK)) {
        const acceptedTextSplit = formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanAgreeCheckboxLabel').split('%s');
        const injectedLinks = [
            formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanIneDocument'),
            formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanPreApprovedDocument'),
            formatText('contractEasyLoanStepThree-contractEasyLoanStepThree_contractEasyLoanContractDocument')
        ];

        let acceptedText = '';
        acceptedTextSplit.map((message, index) => {
            const text = injectedLinks[index];
            const textValue = text ? text : '';
            acceptedText += message + textValue;
        })

        const termsAndConds = {
            acceptedText,
            dateTimeToSave: immContractEasyLoan.get('timestampCheckbox'),
        }
        params.query.termsAndConds = termsAndConds;
    }
    if (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && getState().flagBasedFeatures.get(EVIDENCE_EASY_LOAN)) {
        params.query.operationProcessId = immContractEasyLoan.get('operationProcessIdPolicy')
    }
    return APIPost({ dispatch, endpoint: 'contractEasyLoanFormalize', params });
};

const formalizeCallback = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    dispatch(simpleActions.contractEasyLoanFormalize());
    dispatch(retrieveAresDossier())
        .then(() => dispatch(cancelDossier()))
        .then(() => dispatch(formalizeQuery()))
        .then(() => dispatch(simpleActions.contractEasyLoanFormalizeSuccess()))
        .catch(() => dispatch(simpleActions.contractEasyLoanFormalizeError()));
}

const formalize = () => (dispatch, getState) => {

    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const officeSignature = (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN) && isPrintOfficeMode()) || (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES) && !immFlagBasedFeatures.get(EVIDENCE_EASY_LOAN) && isPrintOfficeMode())

    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => dispatch(formalizeCallback()))
            .catch(() => dispatch(formalizeCallback()));
    };
    !!officeSignature ? validateAndExecute(dispatch, getState, callback, true)
        : validateAndExecute(dispatch, getState, callback, false);
};

const getAsnefValidation = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const paymentDaySelected = immContractEasyLoan.get('paymentDaySelected');
    const productInfo = getProductInfo(paymentDaySelected, immContractEasyLoan);
    const newEasyLoanFeatureFlag = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);

    const params = {
        query: {
            productType: productInfo.type,
            productSubType: productInfo.subtype,
            productStandard: productInfo.standard
        }
    };
    dispatch(simpleActions.contractEasyLoanAsnef());

    return APIGet({ dispatch, endpoint: 'asnefValidation', params })
        .then(response => {
            if (response.response === payrollLoanCommon.ASNEFKO) {
                dispatch(simpleActions.contractEasyLoanAsnefFailure());
            }
            else {
                dispatch(simpleActions.contractEasyLoanAsnefSuccess({ newEasyLoanFeatureFlag }));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanAsnefError());
            } else {
                throw response;
            }
        });
};

const setOfficeStep = step => dispatch => {
    step === "INE" ? dispatch(simpleActions.contractEasyLoanOfficeInePrint()) : dispatch(simpleActions.contractEasyLoanOfficeContractPrint());
};

const validateStep = step => (dispatch, getState) => {
    const visibleStep = getState().contractEasyLoan.get('visibleStep');
    const beforeStep = getState().contractEasyLoan.get('beforeStep');
    const selectedPurpose = getState().contractEasyLoan.get('selectedPurpose');
    const selectedAccount = getState().contractEasyLoan.get('selectedAccount');
    const newEasyLoanFeatureFlag = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
    const evidenceEasyLoanFeatureFlag = getState().flagBasedFeatures.get(EVIDENCE_EASY_LOAN);
    if (visibleStep === WIZARD_FIRST_STEP && !!selectedPurpose && beforeStep === DEFAULT_BEFORE_STEP) {
        dispatch(getAsnefValidation());
    }
    else if (visibleStep === WIZARD_SECOND_STEP && !!selectedAccount) {
        dispatch(getPropositionNumber());
    } else if (visibleStep === WIZARD_THIRD_STEP && newEasyLoanFeatureFlag && !evidenceEasyLoanFeatureFlag) {
        const mailAPIFlag = getState().contractEasyLoan.get('mailAPIFlag');
        mailAPIFlag && dispatch(sendEasyLoanSimpleEmail(EASY_LOAN_MAILTYPE.PRECONTRACTUAL, getState().contractEasyLoan.get('fileEasyLoanIneDocumentId')))
        dispatch(getEasyLoanPolicyDocument());
        dispatch(simpleActions.contractEasyLoanValidateStep({ step, newEasyLoanFeatureFlag }));
    } else if (visibleStep === WIZARD_THIRD_STEP && newEasyLoanFeatureFlag && evidenceEasyLoanFeatureFlag) {
        const immContractEasyLoan = getState().contractEasyLoan;
        const mailAPIFlag = immContractEasyLoan.get('mailAPIFlag');
        const initAPIFlag = immContractEasyLoan.get('initAPIFlag');
        const isContactCenter = __CONTACT_CENTER__;
        const isPrintOffice = isPrintOfficeMode();
        if (isPrintOffice || !isContactCenter) {
            initAPIFlag && dispatch(getContractEasyLoanInitTwo());
        } else {
            dispatch(getLoanContractDocuments(EASY_LOAN_MAILTYPE.CONTRACTUAL));
        }
        mailAPIFlag && dispatch(sendEasyLoanSimpleEmail(EASY_LOAN_MAILTYPE.PRECONTRACTUAL, immContractEasyLoan.get('fileEasyLoanIneDocumentId')))
    }
    else {
        dispatch(simpleActions.contractEasyLoanValidateStep({ step, newEasyLoanFeatureFlag }));
    }
};
const validateStepLoansAndMorgages = step => (dispatch, getState) => {
    const visibleStep = getState().contractEasyLoan.get('visibleStep');
    const beforeStep = getState().contractEasyLoan.get('beforeStep');
    const selectedPurpose = getState().contractEasyLoan.get('selectedPurpose');
    const selectedAccount = getState().contractEasyLoan.get('selectedAccount');
    const newEasyLoanFeatureFlag = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_EASY_LOAN_FLOW_COUNTRIES);
    const evidenceEasyLoanFeatureFlag = getState().flagBasedFeatures.get(EVIDENCE_EASY_LOAN);

    if (visibleStep === WIZARD_FIRST_STEP && !!selectedPurpose && beforeStep === DEFAULT_BEFORE_STEP) {
        dispatch(getAsnefValidation());
    }
    else if (visibleStep === WIZARD_SECOND_STEP && !!selectedAccount) {
        dispatch(getPropositionNumber());
    } else if (visibleStep === WIZARD_THIRD_STEP && newEasyLoanFeatureFlag && !evidenceEasyLoanFeatureFlag) {
        const mailAPIFlag = getState().contractEasyLoan.get('mailAPIFlag');
        mailAPIFlag && dispatch(sendEasyLoanSimpleEmail(EASY_LOAN_MAILTYPE.PRECONTRACTUAL, getState().contractEasyLoan.get('fileEasyLoanIneDocumentId')))
        dispatch(getEasyLoanPolicyDocument());
        dispatch(simpleActions.contractEasyLoanValidateStep({ step, newEasyLoanFeatureFlag }));
    } else if (visibleStep === WIZARD_THIRD_STEP && newEasyLoanFeatureFlag && evidenceEasyLoanFeatureFlag) {
        const mailAPIFlag = getState().contractEasyLoan.get('mailAPIFlag');
        mailAPIFlag && dispatch(sendEasyLoanSimpleEmail(EASY_LOAN_MAILTYPE.PRECONTRACTUAL, getState().contractEasyLoan.get('fileEasyLoanIneDocumentId')))
        dispatch(getLoanContractDocuments(EASY_LOAN_MAILTYPE.CONTRACTUAL));
    }
    else {
        dispatch(simpleActions.contractEasyLoanValidateStep({ step, newEasyLoanFeatureFlag }));
    }
};
const getTotalImportForStepTwo = () => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;

    const endOfMonth = immContractEasyLoan.get('paymentDaySelected') === 'PAYMENT_DAY_END_OF_MONTH';

    dispatch(simpleActions.contractEasyLoanGetTotalImport());
    const params = {
        query: {
            comisionApertura: immContractEasyLoan.get('openingCommission').get('amount'),
            comisionAperturaMin: parseInt(immContractEasyLoan.get('openingCommission').get('minimum')),
            valorPrestamo: parseInt(immContractEasyLoan.get('selectedAmount')),
            cuota: immContractEasyLoan.getIn(['installment', 'amount']),
            numeroPagos: parseInt(immContractEasyLoan.get('selectedTerm')),
            finDeMes: endOfMonth,
            tin: immContractEasyLoan.get('tin')
        }
    };

    return APIGet({ dispatch, endpoint: 'requestEasyLoanContractTotalAmount', params })
        .then(response => {
            dispatch(simpleActions.contractEasyLoanGetTotalImportSuccess({ totalAmount: response.totalAmount }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanGetTotalImportError({ error: response.error }));
            } else {
                throw response;
            }
        });
};


const getInstallmentRequest = (useMaxTerm = false) => (dispatch, getState) => {
    const immContractEasyLoan = getState().contractEasyLoan;
    const loanAmount = immContractEasyLoan.get('selectedAmount');

    const immOpeningCommission = immContractEasyLoan.get("openingCommission");
    const openingCommission = immOpeningCommission.get("amount");
    const openingComissionMinimum = immOpeningCommission.get('minimum');

    const openingCommissionAmount = loanAmount * openingCommission / 100;

    const comisionApertura = openingCommissionAmount < openingComissionMinimum ?
        openingComissionMinimum : openingCommissionAmount;

    const term = useMaxTerm ? immContractEasyLoan.get('maxTerm') : immContractEasyLoan.get('selectedTerm');
    const productInfo = getProductInfo(immContractEasyLoan.get('paymentDaySelected'), immContractEasyLoan);

    const params = {
        query: {
            indCapson: productInfo.indCapson,
            indIntccp: productInfo.indIntccp,
            divisa: immContractEasyLoan.get('currency'),
            importe: immContractEasyLoan.get('selectedAmount'),
            indicaPrecios: 'E', //fixed value
            plazo: term,
            tipodeproducto: productInfo.type,
            subtipodeproducto: productInfo.subtype,
            codigodeestandar: productInfo.standard,
            comisionApertura
        }
    };

    dispatch(simpleActions.contractEasyLoanInstallment());
    return APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params })
        .then(response => dispatch(simpleActions.contractEasyLoanInstallmentSuccess({ response })))
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractEasyLoanInstallmentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getInstallment = () => (dispatch) => {
    dispatch(getInstallmentRequest())
        .then(() => {
            dispatch(getTotalImportForStepTwo());
        })

}
const scrolldownPolicy = () => (dispatch) => {
    dispatch(simpleActions.contractEasyLoanScrollDownPolicy());
}
module.exports = {
    downloadINEDocument,
    downloadPreContractDocument,
    downloanEasyLoanContractDocument,
    formalize,
    getAsnefValidation,
    getHiringDocuments,
    getInstallment,
    onDownloadDocument,
    onPrintDocument,
    preFillContractEasyLoan,
    requestMinInstallmentQuantity,
    simpleActions,
    validateStep,
    validateStepLoansAndMorgages,
    getEasyLoanINEDocument,
    getEasyLoanPolicyDocument,
    getLoanContractDocuments,
    sendEasyLoanSimpleEmail,
    setOfficeStep,
    setInitApiFlag,
    officePrintReset,
    resetMailSent,
    scrolldownPolicy
};
